module.exports = __webpack_public_path__ + "img/map_sky-box.198a7e11.jpg";